import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-square',
  template: `
    <button  style="background-color:sandybrown"  *ngIf="!value">{{ value }}</button>
    <button  style="background-color:#66ccff" *ngIf="value == 'X'">{{ value }}</button>
    <button  style="background-color:#00ff00" *ngIf="value == 'O'">{{ value }}</button>
  `,
  styles: ['button { width: 100%; height: 100%; font-size: 2.5em !important; }']
})
export class SquareComponent  {

  @Input() value: 'X' | 'O';

}
